import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { RequestComposer } from '../components/demandes/RequestComposer';
import { PublicReportsMap } from '../components/demandes/PublicReportsMap';
import { RequestList } from '../components/demandes/RequestList';
export function MesDemandes() {
  return <main className="bg-white" data-id="element-2057" data-mp="2ychyj0rrvtm5">
      <div className="mx-auto max-w-[1180px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2058" data-mp="3c57mvburxamf">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2059" data-mp="3c7aj4dmirzzl">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2060" data-mp="385oyu77nojfd">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2061" data-mp="3h4k67mmfrzk9" />
          <span aria-current="page" data-id="element-2062" data-mp="3h27pfcsezv8s">My requests</span>
        </nav>

        <h1 className="mt-4 text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2063" data-mp="1rq5lddejgwu1">My requests</h1>

        <div className="mt-8 max-w-[880px]" data-id="element-2064" data-mp="1mrud373w6udx">
          <RequestComposer data-id="element-2065" data-mp="2r8qlswzmi9h7" />
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] lg:gap-10" data-id="element-2066" data-mp="2r9rw2z8terxv">
          <PublicReportsMap data-id="element-2067" data-mp="2w8d0zbz0hzsn" />
          <RequestList data-id="element-2068" data-mp="2w5gydac7ymxv" />
        </div>
      </div>
    </main>;
}